export default { plannerStyle: {
  retryLoad: '다시 불러오기',
  applyRevision: '수정 적용',
  localRevision: '수정은 로컬에 보관되며 다시 게시하면 반영됩니다.',
  editRevision: '스타일 수정',
  republish: '다시 게시',
  unpublished: '수정 미게시',
  discard: '수정 취소',
  discardRevision: '게시하지 않은 수정을 취소할까요? 게시된 자료는 유지됩니다.',
  leaveRevision: '수정이 아직 게시되지 않았습니다. 로컬 초안을 보관하고 나갈까요?',
  keepAndLeave: '초안 보관 후 나가기',
  usedSizes: '사이즈 {p0}가 후속 자료에 사용 중입니다. 유지하거나 해당 담당자가 먼저 조정해 주세요. 기존 자료는 삭제되지 않았습니다.',
  usedColors: '색상 {p0}가 후속 자료에 사용 중입니다. 유지하거나 해당 담당자가 먼저 조정해 주세요. 기존 자료는 삭제되지 않았습니다.',
  title: '스타일 정보', create: '신규 품번 생성', drafts: '스타일 초안', noDrafts: '스타일 초안이 없습니다', unnumbered: '스타일 번호 미입력', styleNm: '품명', season: '연도·시즌', draft: '초안', published: '디자인 업무 생성됨', publishedTasks: '게시된 스타일 및 의뢰서 보기',
  source: '자료 출처', manual: '직접 작성', existing: '기존 스타일', fair: '주문 자료', basic: '스타일 정보', order: '주문 정보', people: '담당자', main: '본생산', reorder: '추가 주문', editPrice: '판매가 수정', editOrder: '스타일·주문 정보 수정', openSheet: '의뢰서 보기',
  publish: '스타일 게시', deleteDraft: '초안 삭제', deleteConfirm: '이 스타일 초안을 삭제할까요?', notFound: '스타일 초안이 없습니다', alreadyPublished: '게시된 스타일입니다. 스타일 정보를 열어 주세요.', brandFixed: '브랜드와 게시된 스타일 번호는 변경할 수 없습니다.',
  invalidStyle: '브랜드와 유효한 소분류에 맞는 스타일 번호를 확인해 주세요.', duplicateStyle: '기존 스타일 정보를 열어 주세요.', publishRequired: '품명, 연도·시즌, 색상·사이즈 및 담당자 6명을 지정해 주세요.',
  priceRequired: '상품기획 판매가 입력 대기', quantityRequired: '상품기획 주문 수량 입력 대기, 합계는 0보다 커야 합니다', dateRequired: '입고 요청일 입력 대기', invalidDate: '유효한 날짜를 입력해 주세요', invalidMonth: '판매월 형식: YYYY-MM', invalidYear: '연도는 네 자리 숫자입니다', invalidPrice: '판매가는 음수가 아닌 금액, 소수점 둘째 자리까지 입력합니다', invalidQuantity: '수량은 음수가 아닌 유효한 정수입니다', invalidMatrix: '색상·사이즈 중복 또는 범위 초과',
  pending: '입력 대기', pendingHint: '빈칸은 미입력, 0은 주문 없음입니다.', rangeFirst: '색상과 사이즈 범위를 먼저 지정해 주세요', zero: '빈칸을0으로', import: '스타일 자료 가져오기', paste: '수량 표 붙여넣기', uploadCsv: 'CSV / TSV 파일 선택', template: '스타일 양식 다운로드', preview: '미리보기', apply: '자료 적용',
  importTooLarge: '표가2MB를 초과합니다. 크기를 줄여 주세요.', invalidTable: '열 제목, 열 개수 및 따옴표를 확인해 주세요.', importColumns: '스타일 번호, 품명, 브랜드, 연도, 시즌, 색상, 사이즈, 수량 열이 필요합니다.', importInconsistent: '같은 스타일 정보가 일치하지 않습니다. 한 스타일씩 가져와 주세요.',
  styleCharacters: '스타일 번호는 영문 대문자와 숫자만 입력합니다',
  styleLength: '정식 스타일 번호는10자리입니다',
  styleBrand: '스타일 번호의 앞2자리는 현재 브랜드와 같아야 합니다',
  styleCategory: '스타일 번호의3–4자리는 해당 브랜드의 유효한 소분류여야 합니다',
  fieldRequired: '이 항목을 입력해 주세요',
  categoryUnavailable: '분류를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요',
  copyQuantityTemplate: 'Excel용 양식 복사',
  templateCopied: '양식 복사됨',
  templateInInput: '입력란에 양식을 넣었습니다. Excel에 복사하여 작성해 주세요.',
  quantityPasteHint: '양식을 Excel에 붙여넣고 수량을 입력한 뒤, 색상과 사이즈 제목을 포함한 전체 표를 아래에 붙여넣으세요. 빈칸은 미입력, 0은 미주문입니다.',
  previewSummary: '수량{cells}칸 · 합계{total}개',
  duplicateColumn: '열 제목“{column}”이 중복됩니다. 한 열만 남겨 주세요.',
  rowColumns: '{row}행은{actual}열, 제목은{expected}열입니다. Excel복사 또는 쉼표 구분을 사용해 주세요.',
  noSizeColumns: '사이즈 열이 없습니다. 스타일 수량 양식을 사용해 주세요.',
  unknownSize: '사이즈“{column}”은 현재 스타일의 범위에 없습니다.',
  unknownColor: '{row}행의 색상“{color}”은 현재 스타일의 범위에 없습니다.',
  duplicateColor: '{row}행의 색상“{color}”이 중복됩니다.',
  quantityCell: '{row}행{column}열에는 음수가 아닌 정수를 입력하거나 비워 주세요.',
  totalMismatch: '{row}행의 합계는{total}, 수량 칸의 합계는{sum}입니다. 확인하거나 합계 열을 제거해 주세요.',
  styleDateCode: "품번의 연도·시즌·월 코드가 브랜드 규칙과 다릅니다",
  styleYearMismatch: "연도가 품번의 다섯 번째 코드와 다릅니다",
  styleSeasonMismatch: "시즌이 품번의 여섯 번째 코드와 다릅니다",
  styleMonthMismatch: "판매 월이 품번의 연도·월 코드와 다릅니다",
  styleTailCode: "품번의 마지막 세 자리가 브랜드의 상품군·성별·번호 규칙과 다릅니다",
  invalidSeason: "현재 시즌 목록에서 선택해 주세요",
  unknownMasterSize: "해당 브랜드·품목의 사이즈 목록에서 선택해 주세요",
  unknownMaterialColor: "원단 색상 목록에서 E 또는 B로 시작하는 코드를 선택해 주세요",
  styleCorrectionBlocked: "SAP 전송 이력이 있어 이 요청서에서 품번을 수정할 수 없습니다",
  styleCorrectionRetry: "품번 정보가 변경되었습니다. 새로고침 후 다시 전송해 주세요",
  correctStyleCode: "품번 수정",
  correctionHint: "요청서 번호와 입력된 내용을 유지합니다.",
  fields: { brandCd: '브랜드', styleCd: '스타일 번호', styleNm: '품명', originalStyleNo: '원스타일 번호', genderCd: '성별', productYear: '연도', season: '시즌', salesMonth: '판매월', finalGrade: '상품 등급', businessType: '업무 유형', productType: '상품 유형', styleKind: '스타일 종류', characteristic: '특성', productionCategory: '생산 품목', productionType: '생산 유형', mdpType: 'MDP 유형', mdpStartDate: 'MDP 시작일', salePrice: '판매가CNY', receivingDueDate: '입고 요청일' },
}, plannerBatch: {
  publishing: '발행 중…',
  location: '{p0} {p1}행: {p2}',
  useBatch: '일괄 기록에서 확인 후 발행하세요. 생성하지 않을 품번은 선택을 해제하세요.',
  "title": "품번 일괄 생성",
  "fileTitle": "파일 선택",
  "fileHint": "품번 생성·기획 수량 시트 2개, 최대100품번·5MB.",
  "chooseFile": "Excel 선택",
  "template": "템플릿 다운로드",
  "noFile": "선택한 파일 없음",
  "summary": "총 {n}품번 · 확인 필요 {errors}품번 · 선택 {selected}품번",
  "all": "전체",
  "errors": "확인 필요",
  "empty": "작성한 템플릿을 선택하고 신규 품번을 확인하세요.",
  "sourceRow": "款号生成 · {row}행",
  "range": "색상 × 사이즈",
  "check": "확인 결과",
  "ready": "발행 가능",
  "review": "확인",
  "doneReview": "확인 완료",
  "moreIssues": "추가 확인 {n}건",
  "sourceFields": "원본 필드 보기",
  "row": "행",
  "save": "일괄 초안 저장",
  "publish": "선택 품번 발행",
  "atomicHint": "선택한 모든 품번이 검증되면 발행하며, 실패 시 초안을 보관합니다.",
  "saved": "일괄 초안을 저장했습니다.",
  "published": "발행했습니다. 담당자가 작업 목록에서 확인할 수 있습니다.",
  "publishConfirm": "선택한 {n}품번을 발행하고 담당자에게 전달할까요?",
  "replaceConfirm": "다시 업로드하면 저장하지 않은 정보가 바뀝니다. 계속할까요?",
  "leaveConfirm": "저장하지 않은 변경사항이 있습니다. 떠나기 전에 일괄 초안을 저장하세요.",
  "leave": "나가기",
  "batches": "일괄 초안 및 발행 이력",
  "fileLimit": "파일은5MB이하여야 합니다. 품번 수를 줄여 다시 업로드하세요.",
  "fileFormat": "실제 .xls 또는 .xlsx Excel 파일을 선택하세요.",
  "layout": "템플릿의 시트2개와 헤더·열 순서를 유지하세요.",
  "capacity": "한 번에 최대100품번·1500색상수량행입니다. 필요한 데이터를 삭제하지 말고 파일을 나누세요.",
  "formula": "수식을 값으로 바꾸고 오류 셀을 수정한 후 다시 업로드하세요.",
  "duplicateRows": "중복 품번 또는 색상·사이즈가 있습니다. 확인하세요.",
  "orphanQuantity": "수량 시트의 품번이 품번 시트에 없습니다. 두 시트를 확인하세요.",
  "notNewStyle": "신규 품번 전용입니다. 생산 차수는00이어야 합니다.",
  "rangeConflict": "수량 시트의 색상 또는 사이즈가 품번 범위에 없습니다.",
  "orderConflict": "같은 품번의 색상별 가격·입고요청일·생산유형이 다릅니다.",
  "priceConflict": "두 시트의 가격이 다릅니다. 판매가격을 확인하세요.",
  "quantity": "수량은0이상2147483647이하의 정수여야 합니다.",
  "peopleConflict": "동일 직무에 다른 사람이 기재되었습니다. 실제 담당자를 선택하세요.",
  "categoryConflict": "원본 분류가 품번 분류와 다릅니다. 품번을 확인하세요.",
  "publishBlocked": "선택한 품번에 확인할 정보가 있어 이번 배치는 발행하지 않았습니다.",
  "acceptCurrent": "현재 입력으로 확인",
  "retry": "다시 시도",
  "sourcePage": "원본 기록 {page}페이지",
  "sourcePrevious": "이전",
  "sourceNext": "다음",
  "templateHint": "품번 시트는5행부터, 수량 시트는2행부터 작성하세요. 색상·사이즈·사번은 텍스트로 입력하세요."
} };
